<template>
  <div class="gtb" :class="{ 'gtb--cargando': working }">
    <p class="gtb-lead" v-html="label"></p>

    <!-- El botón de Google, tal cual y sin nada encima.

         Se intentó taparlo con una píldora propia y falló de cinco formas
         distintas, todas la misma de fondo: GIS no dibuja su botón si el
         contenedor no está visible y con tamaño en el momento exacto de
         dibujar, y cualquier truco para esconderlo o superponerle algo acaba
         quitándole una de las dos cosas.

         Así que el botón se deja en paz y el énfasis va ALREDEDOR: el marco
         ámbar a trazos y el halo que late detrás. Se nota igual y no hay nada
         que se pueda desalinear ni colapsar. -->
    <!-- El aviso de carga sí va encima, y eso no contradice lo de arriba:
         solo está mientras el contenedor está VACÍO, y se va en el mismo
         momento en que GIS dibuja. Lo que fallaba era superponerle algo al
         botón ya dibujado. El contenedor, eso sí, no se quita nunca mientras
         se espera: escondido, GIS no dibujaría cuando llegue. -->
    <div class="gtb-slot" v-if="estado !== 'fallo'">
      <div ref="google" class="gtb-real"></div>
      <div v-if="estado === 'cargando'" class="gtb-estado">Cargando Google…</div>
    </div>

    <!-- Respaldo: sin la librería de Google no puede quedar un hueco donde iba
         la única salida de la demo. Se ofrecen las dos salidas: volver a
         intentarlo acá mismo, o el camino largo por el modal. -->
    <div class="gtb-caido" v-if="estado === 'fallo'">
      <p class="gtb-caido-texto">
        No pudimos cargar el inicio de sesión de Google
      </p>
      <button type="button" class="gtb-fallback" @click="reintentar">
        Reintentar
      </button>
      <button type="button" class="gtb-otro" @click="$emit('done')">
        Iniciar sesión
      </button>
    </div>

    <p class="gtb-note" v-if="estado !== 'fallo'">
      Un clic. Sin crear contraseñas.
    </p>
    <!-- La misma linea que va bajo el boton de Google del modal de sesion, con
         el mismo texto: los dos botones crean la cuenta igual, asi que lo que
         se acepta no puede depender de por cual se entro. Va tambien en el
         camino caido, porque ese boton lleva al modal y de ahi al alta.

         Pestana nueva a proposito: esta tarjeta vive dentro de una demo con
         estado, y llevarse la pestana significa volver a empezar. -->
    <p class="gtb-legal">
      Al continuar aceptas los
      <a href="/terminos/" target="_blank" rel="noopener noreferrer">
        Términos y condiciones
      </a>
      y la
      <a href="/privacidad/" target="_blank" rel="noopener noreferrer">
        Política de privacidad
      </a>.
    </p>
    <p class="gtb-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
// El botón real de Google, dentro de la demo.
//
// Por qué existe: la demo ofrecía "Iniciar sesión…" y eso abría el modal, que a
// su vez mostraba el botón de Google. Dos clics para lo mismo. Google Identity
// Services NO deja abrir su ventana desde JavaScript —la API solo expone
// `initialize`, `renderButton`, `prompt` y `disableAutoSelect`, y la ventana se
// abre únicamente al pulsar el botón que la propia librería dibuja—, así que la
// única forma de llegar en un clic es que el botón de la demo SEA ese botón.
//
// La autenticación no se reimplementa: es la misma llamada y el mismo commit
// que hace LoginModalComponent. Solo viaja el `id_token`; el backend valida
// firma, exp y aud contra nuestro client id.
import auth from "@/services/authService";
import { eventoLogin, motivoDeFallo, trackSignUp } from "@/services/analytics";
import { origenDelAlta } from "@/services/origen";

//: Cual de los tres muros de login es este. Los otros dos (`trial` y
//: `service`) los emite src/layouts/utopie/Default.vue.
const ORIGEN = "demo_button";

//: Cuantas veces se pregunta por la libreria de Google antes de darla por no
//: cargada. 40 x 250 ms = 10 segundos, que es de sobra hasta con una conexion
//: mala: pasado eso, el problema no es la red.
const INTENTOS = 40;
const ESPERA_MS = 250;

//: Cuanto se le da a GIS para dejar su boton dibujado despues de aceptar el
//: `renderButton`. El iframe lo crea al vuelo, asi que esto es margen y no
//: espera: si al segundo largo no hay nada, no va a haber nada.
const ESPERA_BOTON_MS = 1500;

export default {
  name: "GoogleTrialButton",
  props: {
    // El texto de la opción del chat, que ya viene con los usos gratis
    // resueltos por signupRewards.
    label: { type: String, default: "Inicia sesión y pruébalo gratis" },
  },
  data() {
    // `estado` es "cargando" | "listo" | "fallo": lo que se ve en el hueco
    // del boton mientras no hay boton.
    return { estado: "cargando", working: false, error: "" };
  },
  created() {
    this._destruido = false;
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    // La primera mitad del embudo: cuantas veces se VE el boton. Sin esto un
    // alza de `login_success` no se puede separar de "lo vio mas gente".
    // `producto` sale de la ruta (`#/<clave>-demo`). Antes iba
    // `service: "demo"`, que decia que estabamos en una demo pero no en cual
    // — y este boton vive en las siete.
    // `origen_login` y no `source`: GA4 se reserva ese nombre para la fuente
    // de campana y un evento con `source` le borra a la sesion el anuncio que
    // la trajo. Los cinco reservados, en backend/marketing/analitica.py.
    eventoLogin("login_wall_shown", { origen_login: ORIGEN });
    this.start();
  },
  methods: {
    start() {
      this.estado = "cargando";
      // Espera a que llegue la librería (la carga public/index.html) y a que el
      // contenedor esté a la vista: GIS no dibuja en algo que esté en
      // display:none, y un mensaje del chat sin revelar lo está.
      let intentos = 0;
      const probar = () => {
        if (this._destruido) return;
        if (this.listo()) {
          this.render();
          return;
        }
        intentos += 1;
        if (intentos > INTENTOS) {
          this.rendirse("gis_no_disponible");
          return;
        }
        this._timer = setTimeout(probar, ESPERA_MS);
      };
      probar();
    },
    listo() {
      const el = this.$refs.google;
      return !!(
        window.google &&
        window.google.accounts &&
        window.google.accounts.id &&
        el &&
        el.isConnected &&
        el.offsetParent !== null
      );
    },
    render() {
      const el = this.$refs.google;
      if (!el) return;
      try {
        window.google.accounts.id.initialize({
          client_id: process.env.VUE_APP_GOOGLE_ID,
          callback: this.onCredential,
          cancel_on_tap_outside: false,
          ux_mode: "popup",
        });
        el.innerHTML = "";
        window.google.accounts.id.renderButton(el, {
          type: "standard",
          // GIS solo admite tres temas —outline, filled_blue, filled_black—
          // y ninguno acepta un color propio. `outline` es blanco con borde
          // gris: es el único que convive con los siete colores de servicio
          // sin pelearse; el azul de Google chocaba con todos menos con uno.
          theme: "outline",
          size: "large",
          shape: "pill",
          text: "continue_with",
          logo_alignment: "left",
          width: this.width(),
          locale: "es",
          click_listener: this.contarElClic,
        });
        // Optimista a proposito: si el boton se dibujo, el aviso de carga se
        // va ya y no un segundo y medio despues. La revision de abajo lo
        // devuelve si resulta que no habia boton.
        this.estado = "listo";
        clearTimeout(this._revision);
        this._revision = setTimeout(this.revisarElBoton, ESPERA_BOTON_MS);
      } catch (e) {
        this.rendirse("gis_no_dibuja");
      }
    },
    /**
     * Se avisa que el boton no se pudo dibujar, y por que.
     *
     * Antes esto era un `this.failed = true` mudo. En los informes, una demo
     * donde el boton nunca aparecio se veia exactamente igual que una donde
     * nadie lo apreto: `login_wall_shown` sin `login_attempt`, y a adivinar.
     * Es la mitad de la sospecha de los navegadores internos.
     *
     * Una sola vez: `render()` se vuelve a llamar al rotar la pantalla.
     */
    avisar(motivo) {
      if (this._avisado) return;
      this._avisado = true;
      eventoLogin("login_failure", {
        method: "google",
        origen_login: ORIGEN,
        reason: motivo,
      });
    },
    /** Y ademas se muestra el respaldo, que es la unica salida de la demo. */
    rendirse(motivo) {
      this.estado = "fallo";
      this.avisar(motivo);
    },
    /**
     * Volver a intentarlo sin recargar la pagina.
     *
     * Empieza por la espera y no por el dibujo: si la libreria nunca llego, no
     * hay nada que redibujar. El contenedor acaba de volver al DOM, asi que se
     * espera al ciclo siguiente para que `listo()` lo encuentre con tamano.
     *
     * Borra la marca a proposito: un reintento a mano es un intento nuevo, y
     * si vuelve a fallar ese segundo fallo cuenta. Lo que no puede contarse
     * dos veces es el mismo fallo automatico.
     */
    reintentar() {
      this._avisado = false;
      this.estado = "cargando";
      this.$nextTick(() => this.start());
    },
    /**
     * Alguien apreto el boton de Google. Lo dice la propia libreria.
     *
     * Antes esto se adivinaba: la pagina pierde el foco y el foco queda en el
     * iframe de Google, luego hubo un clic. Se disparaba igual llegando con el
     * teclado, y llegar con el teclado no es apretar. `renderButton` acepta
     * `click_listener`, que es este mismo dato dicho desde adentro del iframe,
     * donde el clic si se ve.
     *
     * Se cuenta cada clic y no solo el primero: si alguien aprieta tres veces
     * es porque no paso nada, y ese numero —clics por persona— es justo el que
     * dice si el boton responde en el navegador de Instagram.
     */
    contarElClic() {
      eventoLogin("login_click", { method: "google", origen_login: ORIGEN });
    },
    /** ¿Quedo dibujado el boton? GIS lo pone dentro de un iframe suyo. */
    hayBoton() {
      const el = this.$refs.google;
      return !!(el && el.querySelector && el.querySelector("iframe"));
    },
    /**
     * El tercer modo de no tener boton, y el unico que era invisible.
     *
     * Los otros dos —la libreria no llego, `renderButton` tiro excepcion— ya
     * se avisan. Este es el caso en que GIS acepta el render, no se queja, y
     * el hueco se queda vacio igual.
     *
     * El respaldo solo se muestra si no quedo NADA dibujado. Si algun dia GIS
     * dejara de usar un iframe, el boton seguiria ahi funcionando y taparlo
     * por una comprobacion nuestra seria romper la unica salida de la demo
     * para arreglar una medicion; el evento sale igual, y un salto brusco de
     * ese numero al 100% significa que cambio el marcado, no que se rompio el
     * boton.
     */
    revisarElBoton() {
      if (this._destruido || this.hayBoton()) return;
      const el = this.$refs.google;
      if (el && el.childElementCount) {
        this.avisar("gis_no_boton");
        return;
      }
      this.rendirse("gis_no_boton");
    },
    // El ancho del botón de Google se calca del nuestro: es el que recibe el
    // clic, así que si es más angosto quedan bordes muertos donde parece que
    // se puede pulsar y no pasa nada. GIS exige píxeles y no pasa de 400.
    width() {
      const el = this.$refs.google;
      const ancho = el && el.parentElement ? el.parentElement.offsetWidth : 0;
      return Math.max(220, Math.min(400, Math.floor(ancho || 280)));
    },
    // Al rotar o cambiar el ancho hay que volver a dibujarlo: el de Google no
    // es responsivo, lleva un ancho fijo en píxeles.
    onResize() {
      clearTimeout(this._rt);
      this._rt = setTimeout(() => {
        if (this.estado !== "fallo") this.render();
      }, 200);
    },
    onCredential(data) {
      if (!data || !data.credential) return;
      // El mismo trio que el camino de correo y contrasena (authMixin) y que
      // el modal. Sin esto solo se veria `sign_up`, o sea las altas, y este
      // boton es ahora la puerta principal de las demos: sin `login_success`
      // no hay forma de saber si convierte para quien ya tiene cuenta.
      eventoLogin("login_attempt", { method: "google", origen_login: ORIGEN });
      this.working = true;
      this.error = "";
      auth
        .authenticateGoogle({
          id_token: data.credential,
          // El mismo `producto` que ya viaja en `login_wall_shown`, mas la
          // ruta de la demo. Es lo unico que el servidor no ve: todo lo que
          // va despues del `#` se queda en el navegador.
          origen: origenDelAlta(),
        })
        .then(
          (resp) => {
            this.working = false;
            if (resp && resp.token) {
              eventoLogin("login_success", {
                method: "google",
                origen_login: ORIGEN,
              });
              this.$store.commit("login/setUser", resp);
              if (resp.is_new_user) trackSignUp("google");
              // La demo sigue emitiendo lo mismo que emitía al pulsar la
              // opción: el layout ve que ya hay sesión y lleva al servicio.
              this.$emit("done", resp);
            } else {
              eventoLogin("login_failure", {
                method: "google",
                origen_login: ORIGEN,
                reason: "no_token",
              });
              this.error = "No pudimos iniciar sesión. Inténtalo de nuevo.";
            }
          },
          (err) => {
            this.working = false;
            // Antes todo lo que no fuera un 403 se contaba como
            // "server_error", asi que un telefono sin red quedaba anotado como
            // una caida nuestra. El motivo sale del error, y si el error no
            // dice nada sale "desconocido": nunca vacio.
            eventoLogin("login_failure", {
              method: "google",
              origen_login: ORIGEN,
              reason: motivoDeFallo(err),
            });
            this.error = "No pudimos iniciar sesión. Inténtalo de nuevo.";
          }
        );
    },
  },
  beforeDestroy() {
    this._destruido = true;
    window.removeEventListener("resize", this.onResize);
    if (this._timer) clearTimeout(this._timer);
    if (this._rt) clearTimeout(this._rt);
    if (this._revision) clearTimeout(this._revision);
  },
};
</script>

<style>
/* El marco toma el color del servicio.

   `--main-color` lo declara cada demo en línea sobre su envoltorio
   (EurekaDemo, PlanificationDemo, …), así que baja hasta aquí por herencia y
   no hay que pasarlo por props. El ámbar de marca queda de reserva por si
   algún día este botón se usa fuera de una demo. */
.gtb {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 18px 16px 16px;
  border: 2px dashed var(--main-color, #f8b500);
  border-radius: 18px;
  /* Un velo del propio color, muy tenue, en vez de la crema fija de antes:
     con `color-mix` el fondo acompaña al servicio sin declarar siete tintes. */
  background: color-mix(in srgb, var(--main-color, #f8b500) 7%, #fff);
  text-align: center;
  /* El mismo latido que `pulse-option` en el chat: un aro que se expande y se
     apaga. No cambia el tamaño, así que nada se mueve bajo el cursor ni
     desplaza el botón de Google que va dentro. */
  animation: gtbLatido 1.5s ease-out infinite;
}

/* Sin `color-mix` el fondo se queda en blanco, que también sirve. */
@supports not (background: color-mix(in srgb, red 5%, #fff)) {
  .gtb {
    background: #fff;
  }
}

.gtb-lead {
  margin: 0;
  font-weight: 800;
  line-height: 1.3;
  color: #393e46;
}

.gtb-slot {
  position: relative;
  display: flex;
  justify-content: center;
  min-height: 44px;
}

.gtb-real {
  position: relative;
  z-index: 1;
}

/* El aviso de carga ocupa el hueco del botón sin quitarlo del DOM.

   Va DEBAJO de `.gtb-real` (que lleva z-index) y no encima, a propósito:
   mientras el hueco está vacío se ve igual porque no hay nada que lo tape, y
   si alguna vez el estado se quedara mal, un "Cargando…" viejo no podría
   esconder un botón que sí se dibujó. */
.gtb-estado {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: #5c636d;
}

.gtb-caido {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.gtb-caido-texto {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: #5c636d;
}

/* La segunda salida, sin peso: el camino largo por el modal. */
.gtb-otro {
  border: 0;
  padding: 0;
  background: none;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  color: #5c636d;
  text-decoration: underline;
  cursor: pointer;
}

.gtb-note {
  margin: 0;
  font-size: 0.8rem;
  color: #5c636d;
}

/* Un punto por debajo del `gtb-note`: es letra chica de verdad, y no tiene que
   competir con el boton ni con la promesa de arriba. El color es el mismo gris
   del texto secundario del sitio. */
.gtb-legal {
  margin: 4px 0 0;
  font-size: 0.72rem;
  line-height: 1.35;
  color: #5c636d;
}

.gtb-legal a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

.gtb-error {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #d0434e;
}

.gtb--cargando {
  opacity: 0.6;
  pointer-events: none;
}

/* El respaldo sí puede llevar el color del servicio: es nuestro. */
.gtb-fallback {
  border: 0;
  border-radius: 999px;
  padding: 12px 26px;
  background: var(--main-color, #393e46);
  color: #fff;
  font-weight: 800;
  font-family: inherit;
  cursor: pointer;
}

@keyframes gtbLatido {
  0% {
    box-shadow: 0 0 0 0 var(--main-color, #f8b500);
  }
  70% {
    box-shadow: 0 0 0 14px rgba(0, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .gtb {
    animation: none;
  }
}
</style>
